const User = (props) =>{
    return(
        <div>
            <h1>{props.name}</h1>
            <h1>address</h1>        
        </div>
    )
}

export default User;